module.exports = "<p>\n  housekeeping works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/housekeeping/views/housekeeping.component.html
// module id = ./src/app/modules/housekeeping/views/housekeeping.component.html
// module chunks = main